import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';
import { calculateInvoiceTotal } from '../../../../main/apps/ConfiguredApps/silo-invoices/SiloInvoicesTable.helpers';

const SiloInvoiceTotal = ({ props }) => {
    const { watch } = useFormContext();
    const siloInvoice = watch() || {};

    const amount = calculateInvoiceTotal(siloInvoice);
    return <Typography {...props}>Invoice total: {amount.toLocaleString()} lbs</Typography>;
};

export default SiloInvoiceTotal;
